<template>
    <div
        class="flex rounded-2xl bg-white justify-center shadow-xl h-[500px] w-[340px]
           sm:w-[400px]
           xl:w-[450px]
        "
     >
        <div class="flex w-3/4 mt-14 flex-col">
            <div class="text-lg font-bold">Войдите в аккаунт</div>
            <div
                class="flex flex-col"
            >
                <div class="flex flex-col">
                    <LoginInputEmail v-model="userEmail"/>

                    <div class="w-full relative mt-5">
                        <input
                            :type="showPassword ? 'text' : 'password'"
                            id="password"
                            v-model="password"
                            class="h-10 w-full px-3 pt-1 text-xs border-2 border-transparent rounded-md bg-light-blue outline-none focus:outline-none focus:border-blue-600"
                        >
                        <label class="absolute top-1 left-3 transparent small-text-label select-none">Пароль</label>
                        <div v-if="!showPassword" class="absolute right-3 top-3 cursor-pointer" v-on:click="togglePassword">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 fill-gray-500">
                                <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                <path fill-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z" clip-rule="evenodd" />
                            </svg>
                        </div>
                        <div v-else class="absolute right-3 top-3 cursor-pointer" v-on:click="togglePassword">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 fill-gray-500">
                                <path d="M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" />
                                <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" />
                                <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" />
                            </svg>
                        </div>
                    </div>

                    <div v-on:click="login()" class="h-10 w-full bg-blue-600 text-white text-sm flex items-center justify-center select-none cursor-pointer mt-5 hover:bg-blue-700 rounded-md">
                        <div v-if="!isLoading">
                            ВОЙТИ
                        </div>
                        <div v-else>
                            <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    </div>
                    <div id="buttonContainerId" class="my-2"></div>

                    <OauthButtonVK />

                    <div class="mt-5 w-full border-t border-black"></div>
                    <div class="flex items-center justify-between mt-5 w-full">
                        <router-link to="/request-password-reset" class="font-bold text-sm text-blue-600 cursor-pointer hover:text-blue-700">
                            Забыли пароль?
                        </router-link>
                        <router-link :to="{path: '/register', query: {...route.query}}" class="font-bold text-sm text-blue-600 cursor-pointer hover:text-blue-700">
                            Регистрация
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import LoginInputEmail from "@/pages/Login/LoginInputEmail.vue";
import {ref, onBeforeMount} from "vue";
import {createToaster} from "@meforma/vue-toaster";
import {AuthApi} from "@/service/authApi";
import {fpPromise, SITE_URL} from "@/service/config";
import {useRouter, useRoute} from "vue-router";
import {Api} from "@/service/api";
import OauthButtonVK from "@/components/UI/OauthButtonVK.vue";


const yandexRetries = ref(0)

async function loadYandexAuth() {
    initializeYandexAuth()
}


function initializeYandexAuth() {
    try {
        window.YaAuthSuggest.init(
            {
                client_id: '113c1c0e05cb437dab7a17f2836af2fc',
                response_type: 'token',
                redirect_uri: SITE_URL + '/yandex/oauth',
            },
            SITE_URL + '/yandex/oauth',
            {
                view: "button",
                parentId: "buttonContainerId",
                buttonSize: 'm',
                buttonView: 'main',
                buttonTheme: 'light',
                buttonBorderRadius: "5",
                buttonIcon: 'ya',
            }
        )
        .then(function(result) {
            return result.handler()
        })
        .then(data => console.log('Сообщение с токеном', data))
        .catch(error => {
            console.log('Yandex OAuth error:', error);
            if (error.code === 'in_progress') {
                return
            }
            if (yandexRetries.value < 3) {
                yandexRetries.value += 1
                initializeYandexAuth();
            }
        });
    } catch (error) {
        console.warn('Yandex OAuth initialization failed:', error);
    }
    window.reload_self = () => {
        window.location.reload();
    }
}

onBeforeMount(async () => {
    await loadYandexAuth()
})

const toaster = createToaster({ /* options */ });

const router = useRouter()
const route = useRoute()

const userEmail = ref("")

const password = ref("")

const showPassword = ref(false)

const isLoading = ref(false);

function togglePassword() {
    showPassword.value = !showPassword.value
}

function setError(error) {
    toaster.error(error);
}

function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

async function generateFingerPrint() {
    const fp = await fpPromise
    const result = await fp.get()
    return result.visitorId
}

async function login() {
    isLoading.value = true
    if (userEmail.value === "") {
        toaster.error("Email не может быть пустым")
        isLoading.value = false
        return
    }
    if (!validateEmail(userEmail.value)) {
        setError("Значение «Email» не является правильным email адресом.")
        isLoading.value = false
        return
    }
    if (password.value === "") {
        toaster.error("Пароль не может быть пустым")
        isLoading.value = false
        return
    }

    const fingerprint = await generateFingerPrint()

    let data = await AuthApi.login(
        userEmail.value,
        password.value,
        fingerprint,
        "BY_PASSWORD"
    )
    console.log(data)
    if (data.status === "error") {
        setError(data.message)
        isLoading.value = false
        return
    }

    let response = await Api.isUserConfirmed()

    if (!response.is_user_confirmed) {
        isLoading.value = false
        router.push({name: "CodeAcception"})
        localStorage.setItem("isUserConfirmed", "false")
        return
    }
    isLoading.value = false

    const queryParams = route.query;

    if (queryParams && queryParams.redirect) {
        if (queryParams.redirect === 'subscriptions') {
            router.push({name: "SubscriptionPricingView", query: {plan: queryParams.plan, length: queryParams.length}})
        }
    }
    else {
        router.push({name: "WorkspaceView"})
    }

}
</script>


<style scoped>
    .bg-light-blue {
        background-color: #dee8f5;
    }
    .small-text-label {
        font-size: 0.5rem
    }
    .password-criterias:focus ~ .password-criterias-display{
        display: flex;
    }

</style>
